import CommonContainer from "../Container/CommonContainer"
import CommonPagination from "../../Common/CommonPagination"
import { useState, useEffect, useRef } from "react";
import { store } from "../../Store/store";
import * as RateCardService from "../../Services/RateCard/RateCardService"
import toast from "react-hot-toast";
import { FaSearch, FaSpinner, FaTags } from "react-icons/fa";
import { LoadingMessage } from "../../Common/CommonVariables";
import { useSelector } from "react-redux";
import * as DashboardService from '../../Services/Dashboard/DashboardService';
import "./RateCardComponent.css"

// import { store } from '../../Store/store';
import { currencySymbols } from '../../Common/CommonVariables';


const RateCardComponent = () => {
    const [rateCardList, setRateCardList] = useState([])
    const [filteredRateCardList, setFilteredRateCardList] = useState([]) // New state for filtered data
    const [searchTerm, setSearchTerm] = useState('') // New state for search term
    const [loading, setLoading] = useState(false);
    // const selectedSearchRateCard = useRef();

    //RateCard Search code
    const [filteredTests, setFilteredTests] = useState([]);
    const [RateCardData, setRateCardData] = useState([]);
    const [selectedTest, setSelectedTest] = useState(null);
    const [SearchLoading, setSearchLoading] = useState(false);
    const selectedSearchTestName = useRef();
    const userInfo = store.getState();
    const selectedOrg = useSelector((state) => state.selectedOrganization);
    const [rateCardModal, setRateCardModal] = useState(false);

    // Pagination Code
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(15); // Set number of items per page

    const indexOfLastRateCard = currentPage * itemsPerPage;
    const indexOfFirstRateCard = indexOfLastRateCard - itemsPerPage;
    // Use filtered list instead of original list
    const currentRateCardList = filteredRateCardList.slice(indexOfFirstRateCard, indexOfLastRateCard);

    const fetchAllRateCardList = () => {
        setLoading(true)
        RateCardService.GetRateCardDetails("")
            .then(({ data }) => {
                if (data.IsSuccess) {
                    setRateCardList(data.Data);
                    setFilteredRateCardList(data.Data); // Initialize filtered list
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {
                setLoading(false);
            });
    };

    const handleSearchedRateCardList = (term) => {
        if (term.trim() !== '') {
            const filtered = rateCardList.filter(rec =>
                rec.CartItem__r?.TestCode__c?.toLowerCase().includes(term.toLowerCase()) ||
                rec.CartItem__r?.BtbTestName__c?.toLowerCase().includes(term.toLowerCase())
            );
            setFilteredRateCardList(filtered);
            setCurrentPage(1);
        } else {
            setFilteredRateCardList(rateCardList);
        }
    };

    // Handle input change
    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        handleSearchedRateCardList(value);
    };

    useEffect(() => {
        fetchAllRateCardList();
    }, []);

    const fetchRateCard = () => {
        setRateCardData([])
        setFilteredTests([])
        setSelectedTest(null)
        setSearchLoading(true);
        if (selectedSearchTestName.current.value == null || selectedSearchTestName.current.value == "") {
            toast.error("Please enter search data.")
            setSearchLoading(false);
            return;
        }

        const requestData = {
            clientCode: userInfo?.Partner_Account_Details?.MHL_Client_Code__c,
            testSearch: selectedSearchTestName.current.value,
            orgId: selectedOrg?.MHL_Org_Id__c
        };

        DashboardService.FetchPriceFromRNI(requestData).then(({ data }) => {
            if (data.IsSuccess) {
                //debugger;
                setRateCardData(data.Data)
                setRateCardModal(true)
            }
            else {
                setRateCardData([])
                setFilteredTests([])
                setSelectedTest(null)
                toast.error("No data found for searched keyword")
            }
        })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {
                setSearchLoading(false);
            });
    };

    const handleModalClose = () => {
        setRateCardModal(false)
    }

    return (
        <CommonContainer icon={<FaTags size={20}/>} heading="Rate Card">
            <div className="d-flex align-items-center justify-content-between mb-2">
                <div className="d-flex align-items-center gap-2">
                </div>
                <div className=" rounded h-100 rate-card-search-wrapper">

                    {/* <h5>Rate Card&nbsp;</h5> */}
                    <div className="search-box-dashboard position-relative w-100 ">
                        <input
                            type="text"
                            className="form-control rate-card-search"
                            placeholder="Search by Test Name, Code"
                            ref={selectedSearchTestName}
                            value={searchTerm}
                            onChange={handleInputChange}
                            style={{ paddingRight: "45px" }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    fetchRateCard();
                                }
                            }}
                        />
                        <button
                            className="btn custom-sumbitbtn position-absolute d-flex justify-content-center align-items-center"
                            // aria-label="Search by Registration Rate"
                            style={{
                                padding: "5px",
                                right: "0px",
                                height: "35px",
                                width: "90px",
                                top: "50%",
                                fontSize: "13px",
                                borderTopLeftRadius: "0",
                                borderBottomLeftRadius: "0",
                                transform: "translateY(-50%)"
                            }}
                            onClick={() => {
                                fetchRateCard();
                                // handleSelectedRateCard();
                            }}
                            title="Click to get RNI Rate"

                        >
                            {SearchLoading ? <FaSpinner className="fa-spin" /> : <>Get RNI Rate</>}
                            {/* {SearchLoading ?  <FaSearch />} */}
                        </button>
                    </div>
                    {/* <p className="mt-1 mb-2" style={{ fontSize: "10px" }} >
                        <strong style={{ color: "red", }}>Note:</strong> Org selection is mandatory</p> */}
                </div>
            </div>
            <div>
                <div className="table-responsive" >
                    <table className="table table-bordered custom-table" >
                        <thead>
                            <tr>
                                <th> Test Code </th>
                                <th> Test Name </th>
                                <th> MRP ({currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]})</th>
                                <th> Discount(%)</th>
                                {/* <th> Discount</th> */}
                                <th> Net Amount ({currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]})</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                currentRateCardList.length > 0 ? (
                                    currentRateCardList.map((rec, index) => (
                                        <tr key={index} >
                                            <td> {rec.CartItem__r?.TestCode__c} </td>
                                            <td> {rec.CartItem__r?.BtbTestName__c} </td>
                                            <td> {rec.CartItem__r?.BizTBaa__ListPrice__c == 0 ? "-" : rec.CartItem__r?.BizTBaa__ListPrice__c} </td>
                                            <td>
                                                {
                                                    !rec.CartItem__r?.BizTBaa__Discount__c
                                                        ? (
                                                            rec.CartItem__r?.BizTBaa__ListPrice__c > 0 && rec.CartItem__r?.BtbNetRate__c >= 0
                                                                ? (() => {
                                                                    const discount = ((rec.CartItem__r.BizTBaa__ListPrice__c - rec.CartItem__r.BtbNetRate__c) / rec.CartItem__r.BizTBaa__ListPrice__c) * 100;
                                                                    return Number.isInteger(discount) ? `${discount}` : `${discount.toFixed(2)}`;
                                                                })()
                                                                : "-"
                                                        )
                                                        : rec.CartItem__r.BizTBaa__Discount__c
                                                }

                                            </td>


                                            <td> {rec.CartItem__r?.BtbNetRate__c == 0 ? "-" : rec.CartItem__r?.BtbNetRate__c} </td>
                                        </tr>
                                    ))
                                ) : (
                                    !loading ?
                                        <tr><td colSpan="5" className="text-center" > No records found </td></tr > : <tr><td colSpan="5" className="text-center text-muted py-2">
                                            <FaSpinner className="fa-spin me-2" style={{ fontSize: "1.2rem" }} />
                                            <LoadingMessage />
                                        </td></tr >
                                )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination - now based on filtered results */}
                {filteredRateCardList.length > itemsPerPage ? (
                    <CommonPagination
                        pageList={filteredRateCardList}
                        currentPage={currentPage}
                        itemsPerPage={itemsPerPage}
                        setCurrentPage={setCurrentPage}
                    />
                ) : null}
            </div>

            {RateCardData.length > 0 && rateCardModal && (
                <div className="modal-backdrop">
                    <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-md custom-modal-com" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Rate Card</h5>
                                    <button type="button" disabled={loading} onClick={handleModalClose} className="btn-close"></button>
                                </div>
                                <div className="modal-body">
                                    {RateCardData.length > 0 ? (
                                        <div
                                            className="list-group border mb-2"
                                            style={{ maxHeight: "400px", overflowY: "auto", fontSize: "12px", border: '1px', }}
                                        >
                                            {RateCardData.map((test, idx) => (
                                                <button
                                                    key={idx}
                                                    className={`list-group-item list-group-item-action 
                                    ${selectedTest?.testCode === test.testCode ? "fw-bold" : ""}`}
                                                    style={selectedTest?.testCode === test.testCode ? { backgroundColor: "rgb(180, 227, 168)" } : {}}
                                                    onClick={() => {
                                                        setSelectedTest(test);
                                                        // handleSelectedRateCard();
                                                    }}
                                                >

                                                    <div className="d-flex justify-content-between align-items-start mb-1 py-2">
                                                        {/* Left Section */}
                                                        <div className="flex-grow-1 p-0">
                                                            <div className="fw-semibold">
                                                                {test.testName} <span className="text-muted small">({test.testCode})</span>
                                                            </div>
                                                        </div>

                                                        <div className="col-2 text-end p-0">
                                                            <span className="rounded-pill justify-content-end d-flex">{test.testType}</span>
                                                        </div>
                                                    </div>
                                                    <div className="text-muted small mt-1">
                                                        <span className="me-5">MRP: {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]} {test.mrp}</span>
                                                        {/* <span className='fw-bold'>Net: {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{test.amount}</span> */}
                                                        {test.DiscountCategory?.trim() && <span className="me-6">Category: {test.DiscountCategory}</span>}
                                                        <span style={{ float: "right" }}>Net: {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]} <span className='fw-bold'>{test.amount}</span></span>
                                                    </div>

                                                </button>
                                            ))}
                                        </div>
                                    ) : (selectedSearchTestName.current?.value) ? (
                                        <div className="alert alert-warning p-2" style={{ fontSize: "12px" }}>
                                            {SearchLoading ? <LoadingMessage /> : "No test records found."}
                                        </div>
                                    ) : <></>}
                                </div>
                                {/* <div className="modal-footer">
                        <button type="button" disabled={loading} className="btn btn-danger">Close</button>
                        <button type="button" disabled={loading} className="btn btn-primary">Proceed</button>
                    </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </CommonContainer>
    )
}

export default RateCardComponent